import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import classes from '../addScripts.module.scss';
import Select from '../../../../_common/Form/Selects/Select/Select';
import InputField from '../../../../_common/Form/TextFields/InputField';
import DOBPicker from '../../../../_common/Form/DatePickers/DOBPicker/DOBPicker';
import utils from '../../../../../utils/utils';

const leftBlockTemplate = [
  {
    label: 'Written Date',
    path: 'writtenDate',
    type: 'calendar',
  },
  {
    label: 'Bill on Date',
    path: 'billOnDate',
    type: 'calendar',
  },
  {
    label: 'RX Number',
    path: 'rxNumber',
    type: 'input',
    validation: 'number',
  },
  {
    label: 'Diagnosis',
    path: 'diagnosis',
    type: 'input',
  },
  {
    label: 'Secondary Diagnosis',
    path: 'secDiagnosis',
    type: 'input',
  },
  {
    label: '# of Refills',
    path: 'refills',
    type: 'input',
    validation: 'currency',
  },
  {
    label: '# of Refills Remaining',
    path: 'refillsRemaining',
    type: 'input',
    validation: 'currency',
  },
  {
    label: 'Quantity',
    path: 'quantity',
    type: 'input',
    validation: 'currency',
  },
  {
    label: 'Days Supply',
    path: 'daysSupply',
    type: 'input',
    validation: 'number',
  },
  {
    label: 'Directions',
    path: 'directions',
    type: 'input',
  },
];

const rightBlockTemplate = [
  {
    label: 'Sales Code',
    path: 'salesCode',
    type: 'input',
  },
  {
    label: 'Cost',
    path: 'cost',
    type: 'input',
    validation: 'currency',
  },
  {
    label: 'Primary Insurance Pay',
    path: 'primInsPay',
    type: 'input',
    validation: 'currency',
  },
  {
    label: 'Secondary Insurance Pay',
    path: 'secInsPay',
    type: 'input',
    validation: 'currency',
  },
  {
    label: 'Patient Pay',
    path: 'patientPay',
    type: 'input',
    validation: 'currency',
  },
];

const copayNetworkOptions = [
  'Cancer Care Foundation',
  'Chronice Disease Fund',
  'Health Well',
  'LLS',
  'Patient Access Network',
  'Patient Advocate',
  'Patient Service Inc',
  'Safety Net Foundation',
  'Good Days',
  'Coupon',
  'Voucher',
  'Copay Card',
];

const Processing = ({
  processingInfo, setProcessing, showCopayCardField, errors,
}) => {
  const onKeyPress = useCallback((e, validationType, isPaste) => {
    if (validationType === 'currency') {
      utils.keyPressCurrency(e, isPaste);
    } else if (validationType === 'number') {
      utils.keyPressOnlyNumber(e, isPaste, true);
    } else {
      () => {};
    }
  }, []);

  return (
    <div className={classes.processing_wrapper}>
      <h4>Processing</h4>

      <div className={classes.fields_block}>
        <div className={classes.fields_left_block}>
          {leftBlockTemplate.map(({
            type, path, label, validation,
          }) => (
            <Fragment key={path}>
              {
                type === 'calendar'
                  ? (
                    <DOBPicker
                      label={label}
                      date={processingInfo[path]}
                      dateFormat="YYYY-MM-DD"
                      onChange={(date) => setProcessing(path, date)}
                      autoValidation={false}
                      error={errors[path]}
                    />
                  )

                  : (
                    <InputField
                      label={label}
                      value={processingInfo[path]}
                      error={errors[path]}
                      onChange={(value) => setProcessing(path, value)}
                      onKeyPress={(e) => onKeyPress(e, validation)}
                      onPaste={(e) => onKeyPress(e, validation, true)}
                    />
                  )
              }
            </Fragment>
          ))}
        </div>

        <div className={classes.fields_right_block}>
          {rightBlockTemplate.map(({ path, label, validation }) => (
            <InputField
              key={path}
              label={label}
              value={processingInfo[path]}
              onChange={(value) => setProcessing(path, value)}
              onKeyPress={(e) => onKeyPress(e, validation)}
              onPaste={(e) => onKeyPress(e, validation, true)}
            />
          ))}

          {showCopayCardField && (
            <InputField
              label="Copay Before Copay Card"
              value={processingInfo.copay_Card}
              onChange={(value) => setProcessing('copay_Card', value)}
              onKeyPress={(e) => onKeyPress(e, 'currency')}
              onPaste={(e) => onKeyPress(e, 'currency', true)}
            />
          )}
        </div>
      </div>

      <div className={classes.copay_assistance_wrapper}>
        <h4>Copay Assistance</h4>

        <div>
          <Select
            label="Status"
            onChange={(option) => setProcessing('copayApproval', option)}
            currentOption={processingInfo.copayApproval}
            options={['Approved', 'Denied']}
          />

          {processingInfo.copayApproval === 'Approved' && (
          <Select
            label="Status"
            onChange={(option) => setProcessing('copayNetwork', option)}
            currentOption={processingInfo.copayNetwork}
            options={copayNetworkOptions}
          />
          )}
        </div>

        {processingInfo.copayApproval === 'Approved' && (
        <InputField
          wrapperClassName={classes.network_pay}
          label="Network Pay"
          value={processingInfo.networkPay}
          onChange={(value) => setProcessing('networkPay', value)}
        />
        )}
      </div>
    </div>
  );
};

Processing.propTypes = {
  processingInfo: PropTypes.object.isRequired,
  setProcessing: PropTypes.func.isRequired,
  showCopayCardField: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
};

export default Processing;
